import Helpers from '../../modules/Helpers'



if (document.getElementsByClassName('booking').length > 0) {

    const wrapper = document.getElementsByClassName('booking')[0]
    const form = new Helpers(wrapper).getClosest('form')
    
    // Rebooking
    const rebookingPanel = form.getElementsByClassName('booking__rebooking')
    if (rebookingPanel.length > 0) {
        const rebookingSelect = rebookingPanel[0].getElementsByTagName('select')[0]

        const updateRebookingDisplay = () => {
            const show = parseInt(rebookingSelect.value) === 1
            const controls = rebookingPanel[0].getElementsByClassName('booking__rebooking--yes')
            new Helpers(controls).setAttributes({ 'aria-hidden': !show })
            if (!show) {
                Array.from(rebookingPanel[0].getElementsByTagName('input')).forEach(input => input.value = '')
            }
        }
        new Helpers(rebookingSelect).eventListener((e) => {
            updateRebookingDisplay()
        }, 'change')

        updateRebookingDisplay()
    }

    // Insurance
    const insurancePanel = form.getElementsByClassName('booking__insurance')
    if (insurancePanel.length > 0) {
        const insuranceSelect = insurancePanel[0].getElementsByTagName('select')[0]

        const updateInsuranceDisplay = () => {
            const show = parseInt(insuranceSelect.value, 10) === 1
            const controls = insurancePanel[0].getElementsByClassName('booking__insurance--yes')
            new Helpers(controls).setAttributes({ 'aria-hidden': !show })
            if (!show) {
                Array.from(insurancePanel[0].getElementsByTagName('input')).forEach((cb) => {
                    cb.checked = false
                })
            }
        }
        new Helpers(insuranceSelect).eventListener(updateInsuranceDisplay, 'change')

        updateInsuranceDisplay()
    }

    // Card Type
    const cardType = form.getElementsByClassName('card-type')
    if (cardType.length > 0) {
        const cardTypeInput = form[cardType[0].name]

        const setCardTypeVisibility = () => {
            const maestro = cardTypeInput.value === 'MO'

            new Helpers(document.getElementsByClassName('maestro-only')).setAttributes({ 'aria-hidden': !maestro })
            // toggle disabled state on inputs to ensure any value is not returned
            const validFromInputs = document.querySelectorAll('.maestro-only select')
            if (!maestro) {
                new Helpers(validFromInputs).setAttributes({ 'disabled': "disabled" })
            } else {
                new Helpers(validFromInputs).removeAttributes(['disabled'])
            }
            
        }

        setCardTypeVisibility()

        new Helpers(cardTypeInput).eventListener((e) => {
            setCardTypeVisibility()
        }, 'change')

        const cardTypeSelector = form.getElementsByClassName('booking__card-types')
        if (cardTypeSelector.length > 0) {
            Array.from(cardTypeSelector).forEach((cts) => {
                new Helpers(cts.getElementsByTagName('img')).eventListener((e) => {
                    cardTypeInput.value = e.target.getAttribute('data-cardType')
                })
            })
        }

    }
    

    // Cardholder Address
    const cardholderAddress = document.getElementsByClassName('cardholder-address')
    if (cardholderAddress.length > 0) {
        const cardholderAddressInput = form[cardholderAddress[0].name]

        const setCardholderAddressVisibility = () => {
            const useAlternativeCardholder = parseInt(cardholderAddressInput.value, 10) === 1
            new Helpers(document.getElementsByClassName('alternative-cardholder')).setAttributes({
                'aria-hidden': !useAlternativeCardholder,
                disabled: useAlternativeCardholder ? null : 'disabled',
            })
        }

        setCardholderAddressVisibility()

        new Helpers(cardholderAddressInput).eventListener(() => {
            setCardholderAddressVisibility()
        }, 'change')
    }
}

if (document.getElementsByClassName('sagev4-browserparams').length > 0) {
    // populate sagepay browser info
    document.querySelector('input[name$="hdnBrowserJavascriptEnabled"]').value = '1'
    document.querySelector('input[name$="hdnBrowserJavaEnabled"]').value = navigator.javaEnabled() ? '1' : '0'
    // need to add a conditional on the colorDepth as 10 bit displays might return "30"
    // which is not a valid value for 3DSv2
    document.querySelector('input[name$="hdnBrowserColorDepth"]').value = (() => {
        switch (screen.colorDepth) {
        case 30:
            return 24
        default:
            return screen.colorDepth
        }
    })()
    document.querySelector('input[name$="hdnBrowserScreenHeight"]').value = screen.height
    document.querySelector('input[name$="hdnBrowserScreenWidth"]').value = screen.width
    document.querySelector('input[name$="hdnBrowserTimezoneOffset"]').value = (new Date()).getTimezoneOffset()
    document.querySelector('input[name$="hdnBrowserLanguage"]').value = navigator.language

    const iframeContentWidth = parseInt(document.querySelector('.sagev4-browserparams').clientWidth, 10)
    let challengeWindowSize = '01'
    if (iframeContentWidth >= 390) { challengeWindowSize = '02' }
    if (iframeContentWidth >= 500) { challengeWindowSize = '03' }
    if (iframeContentWidth >= 600) { challengeWindowSize = '04' }
    document.querySelector('input[name$="hdnChallengeWindowSize"]').value = challengeWindowSize
}
